import React from 'react';
import { useMediaPredicate } from 'react-media-hook';
import classNames from 'classnames';

import { media } from 'utilities/browser';
import { addClassDuringActivity } from 'utilities/dom';
import { addToCart, redirectToCart } from 'features/cart';
import { Reporter } from 'features/dataCapture';
import { dataCaptureTimeout } from 'ui/config';

import dynamicImport from '../../../../webpack/dynamicImport.macro';

import './ProductSortItemAddToCartButton.scss';

const { reporter } = window.lp.dataCapture;

type ProductSortItemAddToCartButtonProps = {
	shortSku: string;
	skuInputType: number;
}

function ProductSortItemAddToCartButton ({ shortSku, skuInputType }: ProductSortItemAddToCartButtonProps) {

	const isMediaDesktop = useMediaPredicate(media.DESKTOP);
	const buttonSizeClass = isMediaDesktop ? 'xSmall' : 'small';
	const btnClassList = classNames('ProductSortItemAddToCartButton', 'calloutBtn', buttonSizeClass);
	let targetBtn: HTMLButtonElement | null = null;
	let addToCartRecordId: any;

	const waitForDataCaptureAndRedirectToCart = () => {

		if (!window.lp.globals.enableDataCapture) {

			redirectToCart();
			return;

		}

		const parentElement = targetBtn?.closest('.ProductSortItem');
		const pageImg = parentElement?.querySelector(`img[data-sku='${shortSku}']`);
		const skuViewRecord = reporter.getRecordByElement(pageImg);
		const skuViewRequest = skuViewRecord ? skuViewRecord.promise : reporter.track(Reporter.getSkuViewData(pageImg));
		const atcRecord = reporter.getRecordById(addToCartRecordId);
		const atcRequest = atcRecord.promise;
		const timeout = window.setTimeout(redirectToCart, dataCaptureTimeout);
		Promise.all([ skuViewRequest, atcRequest ]).finally(() => {

			window.clearTimeout(timeout);
			redirectToCart();

		});

	};

	const addToCartClickFun = function (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {

		targetBtn = e.target as HTMLButtonElement;
		e.preventDefault();

		const data = [ { ShortSku: shortSku, Quantity: 1, SkuInputType: skuInputType } ];

		if (window.lp.globals.enableDataCapture) {

			reporter.trackAddToCart(data, targetBtn);
			addToCartRecordId = reporter.getLastRecordId();

		}

		if (shortSku) {

			const request = addToCart({
				arrData: data,
				successCallback: waitForDataCaptureAndRedirectToCart,
				errorCallback: (errors, xhr, response) => {

					dynamicImport(
						'mobile/showAddToCartFailureModal',
						'../../../../../features/cart/mobile/showAddToCartFailureModal'
					).then((module: any) => {

						const showAddToCartFailureModal = module.default;
						showAddToCartFailureModal({
							cartStatus: errors,
							response,
							fromModal: false
						});

					});

				}
			});

			addClassDuringActivity(targetBtn, 'noPointerEvents loading', request);

		}

	};

	return (
		<button className={btnClassList} onClick={addToCartClickFun} data-sku={shortSku} type="button">
			Add To Cart
		</button>
	);

}

export default ProductSortItemAddToCartButton;
